import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { action, makeObservable } from 'mobx'
import i18n from 'i18next'
import * as R from 'ramda'

import ENUM from '../ENUM'
import Select from '../../form/Select'
import CheckboxCol from './CheckboxCol'
import Switch from '../../../UniformComponents/Switch'
import Checkbox from '../../form/Checkbox'
import AnimateHeight from 'react-animate-height'

@observer
class MultiQuestionSlideConfig extends Component {
    @observable codingAccordian = {}

    constructor(props) {
        super(props)
        const { presentationStore, config } = props
        const { question, slide } = config
        const { questionTypeCode } = question
        this.questionOptions = presentationStore.getConfigFormOptions(questionTypeCode, question, {})
        this.presentationStore = props.presentationStore

        slide.display = this.questionOptions.filters
            .find((item) => item.name === ENUM().display).options[0].value

        makeObservable(slide)
    }

    fetchData = async (question) => {
        const { presentationStore } = this.props
        const { store } = presentationStore
        const request = JSON.stringify({
            questionId: question.id,
            questionType: question.questionTypeCode,
            questionOptionId: null,
            filter: {
                state: ['completed'],
                surveyDataIds: [],
                question: {
                    ruleType: 'ruleGroup',
                    rules: [],
                },
                campaign: {
                    ruleType: 'ruleGroup',
                    rules: [],
                },
                responseDate: {
                    ruleType: 'ruleGroup',
                    rules: [],
                },
            },
        })
        const response = await store.http.post(`/report/v1/${store.survey.id}/textquestion`, request)

        const questionCoding = {}

        let total = 0
        const labels = response.labels.map((label, index) => {
            const coding = R.pathOr([], ['categories', index], response)
            const numberOfResponses = R.pathOr(0, ['numberOfResponses', index], response)

            coding.forEach((category) => {
                questionCoding[category] ??= 0
                questionCoding[category] += 1
            })

            total += numberOfResponses

            return {
                label,
                coding: new Set(coding),
            }
        })
        const otherKey = 'Other'
        const other = R.pick([otherKey], questionCoding)
        const sortedQuestionCoding = Object.entries(R.omit([otherKey], questionCoding))
            .sort((a, b) => b[1] - a[1])
            .map(([k, v]) => ({
                name: k,
                value: v,
                pct: (v / (total || 1) * 100),
            }))

        return {
            labels,
            categories: [...sortedQuestionCoding, { name: otherKey, value: other[otherKey] ?? 0, pct: (other[otherKey] ?? 0 / (total ?? 1) * 100) }],
        }
    }

    onChangeHandler = ({ name, value }) => {
        const { config } = this.props
        const { slide } = config

        slide[name] = value
    }

    @action
    updatePowerpointObject = (fieldName, {
        name,
        value,
    }) => {
        const { config } = this.props
        const { slide } = config

        slide.comparisonSurveyIds = slide.comparisonSurveyIds
            .slice()
            .map((benchmark) => {
                if (benchmark.value === name) {
                    benchmark.checked = value
                }
                return benchmark
            })
    }

    changeQuestion = async (obj, index) => {
        const { presentationStore, config } = this.props
        const { slide } = config
        const { getConfigFormOptions } = presentationStore
        const { questionTypeCode } = obj.question
        const { multiQuestion } = slide

        const supportAverage = ['RD', 'CH', 'SB'].includes(questionTypeCode) && obj.question.optionSet.options.some(({ reportingValue }) => reportingValue)
        const questions = multiQuestion.slice()
        const slideQuestion = questions[index]
        const configOptions = getConfigFormOptions(questionTypeCode, obj.question, {})

        slideQuestion.pageQuestionId = obj.value
        slideQuestion.filters = configOptions.filters
        slideQuestion.chartType = slideQuestion.filters.find(({ name }) => name === 'chartType')?.options?.[0]?.value
        slideQuestion.ranking = slideQuestion.filters.find(({ name }) => name === 'ranking')?.options?.[0]?.value
        slideQuestion.supportAverage = supportAverage
        slideQuestion.showAverage = false
        slideQuestion.benchmarks = slideQuestion.benchmarks.slice().map((b) => {
            b.checked = false
            return b
        })
        slideQuestion.comparisonSurveyIds = slideQuestion.comparisonSurveyIds.slice().map((b) => {
            b.checked = false
            return b
        })

        if (['TX', 'TA'].includes(questionTypeCode)) {
            slideQuestion.verbatim = await this.fetchData(obj.question)
            slideQuestion.coding = []
            slideQuestion.codingAccordian = {}
            slideQuestion.ranking = 'noRanking'
            slideQuestion.chartType = 'verbatim'
        } else {
            Reflect.deleteProperty(slideQuestion, 'verbatim')
            Reflect.deleteProperty(slideQuestion, 'coding')
            Reflect.deleteProperty(slideQuestion, 'codingAccordian')
        }

        slide.multiQuestion = questions
    }

    updateBenchmark = ({ value, name }, index) => {
        const { config } = this.props
        const { slide } = config

        const { multiQuestion } = slide
        const questions = multiQuestion.slice()
        const slideQuestion = questions[index]

        slideQuestion.benchmarks = slideQuestion.benchmarks.slice().map((b) => {
            if (b.value === name) {
                b.checked = value
            }
            return b
        })
        slide.multiQuestion = questions
    }

    updateComparison = ({ value, name }, index) => {
        const { config } = this.props
        const { slide } = config

        const { multiQuestion } = slide
        const questions = multiQuestion.slice()
        const slideQuestion = questions[index]

        slideQuestion.comparisonSurveyIds = slideQuestion.comparisonSurveyIds.slice().map((b) => {
            if (b.value === name) {
                b.checked = value
            }
            return b
        })
        slide.multiQuestion = questions
    }

    changeChartType = (obj, index) => {
        const { config } = this.props
        const { slide } = config

        const { multiQuestion } = slide

        const questions = multiQuestion.slice()
        const slideQuestion = questions[index]
        slideQuestion.chartType = obj.value

        slide.multiQuestion = questions
    }

    changeRanking = ({ value }, index) => {
        const { config } = this.props
        const { slide } = config

        const { multiQuestion } = slide

        const questions = multiQuestion.slice()
        const slideQuestion = questions[index]
        slideQuestion.ranking = value

        slide.multiQuestion = questions
    }

    changeShowAverage = (value, index) => {
        const { config } = this.props
        const { slide } = config

        const { multiQuestion } = slide

        const questions = multiQuestion.slice()
        const slideQuestion = questions[index]
        slideQuestion.showAverage = value

        slide.multiQuestion = questions
    }

    setAccordian = (name, index) => {
        const { config } = this.props
        const { slide } = config

        const { multiQuestion } = slide

        const questions = multiQuestion.slice()
        const slideQuestion = questions[index]
        slideQuestion.codingAccordian[name] = !slideQuestion.codingAccordian[name]

        slide.multiQuestion = questions
    }

    setCodingOption = (name, value, index) => {
        const { config } = this.props
        const { slide } = config

        const { multiQuestion } = slide

        const questions = multiQuestion.slice()
        const slideQuestion = questions[index]
        const [category, label] = name.split('_')
        const clonedOptions = slideQuestion.coding.slice()
        const categoryIndex = clonedOptions.findIndex((v) => v.name === category)

        if (value) {
            if (clonedOptions[categoryIndex].comments.length === 2) {
                clonedOptions[categoryIndex].comments.shift()
            }
            clonedOptions[categoryIndex].comments.push(label)
        } else {
            clonedOptions[categoryIndex].comments = clonedOptions[categoryIndex].comments.filter((v) => v !== label)
        }

        slideQuestion.coding = clonedOptions

        slide.multiQuestion = questions
    }

    setQuestionCoding = ({ name, value }, index) => {
        const { config } = this.props
        const { slide } = config

        const { multiQuestion } = slide

        const questions = multiQuestion.slice()
        const slideQuestion = questions[index]
        const { categories } = slideQuestion.verbatim
        const { pct } = categories.find((c) => c.name === name) ?? { pct: 0 }

        if (value) {
            if (slideQuestion.coding.length === 2) {
                slideQuestion.coding.shift()
            }
            slideQuestion.coding.push({
                name,
                pct,
                comments: [],
            })
        } else {
            slideQuestion.coding = slideQuestion.coding.filter((v) => v.name !== name)
        }

        slide.multiQuestion = questions
    }

    renderVerbatim = (question, index) => {
        const { verbatim, coding } = question

        if (!verbatim) return null

        return (
            <div>
                {verbatim.categories.map(({ name, value }) => (
                    <Checkbox
                        label={`${name} (${value})`}
                        name={name}
                        onBlur={(obj) => this.setQuestionCoding(obj, index)}
                        checked={coding.find((o) => o.name === name)}
                    />
                ))}
            </div>
        )
    }

    renderCoding = (question, index) => {
        const { verbatim, coding } = question

        if (!verbatim) return null

        return (
            <div>
                {coding.map(({ name: category, comments }) => (
                    <div
                        style={{
                            border: '1px solid #CADAE1',
                            borderRadius: '6px',
                            background: '#FFF',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                background: '#FAFBFD',
                                borderRadius: '6px',
                                alignItems: 'center',
                                padding: '10px',
                            }}
                            onClick={() => this.setAccordian(category, index)}
                        >
                            {category}
                            <i className={`fa-light fa-chevron-${question.codingAccordian[category] ? 'up' : 'down'}`} />
                        </div>
                        <AnimateHeight
                            duration={250}
                            height={question.codingAccordian[category] ? 'auto' : 0}
                            className={question.codingAccordian[category] ? 'question-content' : ''}
                            style={{
                                padding: '10px',
                            }}
                        >
                            {verbatim.labels.filter((label) => label.coding.has(category)).map(({ label }) => (
                                <Checkbox
                                    name={`${category}_${label}`}
                                    label={label}
                                    checked={comments.includes(label)}
                                    onBlur={({ name, value }) => this.setCodingOption(name, value, index)}
                                />
                            ))}
                        </AnimateHeight>
                    </div>
                ))}
            </div>
        )
    }

    renderAverageSwitch = (question, index) => {
        if (!question.supportAverage) return null

        return (
            <Switch
                onToggle={(value) => this.changeShowAverage(value, index)}
                label="Chart averages"
                value={question.showAverage}
            />
        )
    }

    renderOtherSettings = (question, index) => {
        const { config } = this.props
        const filters = (question.filters ?? []).filter(({ name }) => ['benchmarks', 'comparisonSurveyIds'].includes(name))

        return (
            <div style={{ display: 'flex' }}>
                {filters.map(({ name }) => (
                    <>
                        {name === 'benchmarks' && (
                            <CheckboxCol
                                callback={(_, obj) => this.updateBenchmark(obj, index)}
                                key={`benchmarks_${question.id}`}
                                id={`benchmarks_${question.id}`}
                                // name={filter.name}
                                config={config}
                                title="Select Benchmarks"
                                grid={{ xs: 1 }}
                                checkboxes={question.benchmarks}
                                cssClass="checkbox-cols exploriNativeCheckbox"
                            />
                        )}
                        {name === 'comparisonSurveyIds' && (
                            <CheckboxCol
                                callback={(_, obj) => this.updateComparison(obj, index)}
                                key={`comparisonSurveyIds${question.id}`}
                                id={`comparisonSurveyIds${question.id}`}
                                // name={filter.name}
                                config={config}
                                title="Select years"
                                grid={{ xs: 1 }}
                                checkboxes={question.comparisonSurveyIds}
                                cssClass="checkbox-cols exploriNativeCheckbox"
                            />
                        )}
                    </>
                ))}
            </div>
        )
    }

    renderGeneralSettings = (question, index) => {
        const { presentationStore } = this.props
        const general = (question.filters ?? []).filter(({ groupId }) => groupId === 'general')

        if (general.length === 0) return null

        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBlock: 8 }}>
                {general.map(({ name, options }) => (
                    <Select
                        key={`general_${name}`}
                        label={presentationStore.getSelectLabel(name)}
                        options={options}
                        onBlur={(obj) => name === 'ranking' ? this.changeRanking(obj, index) : this.changeChartType(obj, index)}
                        value={question[name]}
                    />
                ))}
            </div>
        )
    }

    renderQuestion = (question, index) => {
        const {
            presentationStore,
            config,
        } = this.props

        const { slide } = config
        const { multiQuestion } = slide

        const l = multiQuestion.length

        const { allQuestions, store } = presentationStore

        const questionOptions = allQuestions.map(({ question, id }) => ({
            value: id,
            question,
            label: presentationStore.getShortTitle(question, store),
        })).filter(({ question: { questionTypeCode } }) => (l === 2 && index === 1) || !['TX', 'TA'].includes(questionTypeCode))

        return (
            <div style={{ flex: 1, border: '1px solid #CADAE1', borderRadius: '10px', padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px', minHeight: '200px' }}>
                <Select
                    label="Question"
                    options={questionOptions}
                    onBlur={(obj) => this.changeQuestion(obj, index)}
                    value={question.pageQuestionId}
                />
                {this.renderGeneralSettings(question, index)}
                {this.renderOtherSettings(question, index)}
                {this.renderAverageSwitch(question, index)}
                {this.renderVerbatim(question, index)}
                {this.renderCoding(question, index)}
            </div>
        )
    }

    render() {
        const {
            config,
        } = this.props

        const { slide } = config
        const { multiQuestion } = slide

        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', flex: 1 }}>
                <div
                    className="question-select-col"
                    style={{
                        display: 'flex',
                        gap: '10px',
                        flex: 1,
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            gap: '10px',
                        }}
                    >
                        {this.renderQuestion(slide.multiQuestion[0], 0)}
                        {this.renderQuestion(slide.multiQuestion[1], 1)}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            gap: '10px',
                        }}
                    >
                        {multiQuestion.length > 2 && (
                            this.renderQuestion(slide.multiQuestion[2], 2)
                        )}
                        {multiQuestion.length > 3 && (
                            this.renderQuestion(slide.multiQuestion[3], 3)
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default MultiQuestionSlideConfig
